export default {
      id: "localisation-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#localisation-usage",
      toString: function () {
        return this.url;
      }
    }